export default {"src":"/login-app/[GIT_HASH]/_next/static/media/cpu.9d9d24df.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};